import { Card } from '../../components/ui/Card';

/**
 * The heading card at the top of the Brand assets and style and Workflow pages (spec:184): the page's
 * heading and its one-line description in one card, no icon.
 */
export function PageHeadingCard({ title, description }: { title: string; description: string }) {
  return (
    <Card>
      <div className="px-5 py-4">
        <h2 className="text-base font-semibold text-ink">{title}</h2>
        <p className="mt-0.5 text-sm text-ink-muted">{description}</p>
      </div>
    </Card>
  );
}
